import React from 'react'
import { If, Else } from "react-condition";
import { IMAGE_SIZE, DOC_SIZE, VIDEO_SIZE, DOMAIN } from "../../../umConfig";
import cx from "classnames";

const CceFormSubmitButton = ({step,setAgreed,onClickFormSubmit,agreed}) => {
  return (
    <>
    <If test={step === 1}>
      <div className="form-check mb-3 mt-2 ">
        <input
          className="form-check-input"
          type="checkbox"
          id="agreement"
          checked={agreed}
          onChange={() => {
            setAgreed((b) => !b);
          }}
        />
        <label
          className="form-check-label"
          for="agreement"
        >
          I agree to all the terms and conditions.
        </label>
      </div>
      <button
        {...{
          className: cx(
            "btn",
            { "btn-secondary": !agreed },
            {
              "btn-primary":
                agreed &&
                window.location.hostname !== DOMAIN,
            },
            {
              kochar__color:
                window.location.hostname ===
                  DOMAIN && agreed,
            }
          ),
          type: "submit",
          onClick: (e) => onClickFormSubmit(e),
          disabled: !agreed,
        }}
      >
        Save & Continue
      </button>
    </If>
    <If test={step === 2}>
      <button
        {...{
          className: cx("btn", "btn-primary"),
          type: "submit",
          onClick: (e) => onClickFormSubmit(e),
        }}
      >
        SUBMIT
      </button>
    </If>
  </>
  )
}

export default CceFormSubmitButton